import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class ZonesService {

  constructor(private http: HttpClient) { }

  getZones(queryParams?) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.ZONES, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  saveZone(id, payload) {
    if (id) {
      return this.http.put<any>(urls.BASE_URL + urls.ZONES + `/${id}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.ZONES, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }
  deleteZone(id) {
    return this.http.post<any>(urls.BASE_URL + urls.ZONES + `/${id}`,{})
      .pipe(
        catchError(errorHandl)
      );
  }
}
